export default [
    {
        type: 'text',
        model: 'business_legal_name',
        placeholder: 'Business Name',
        rules: 'required|max:100'
    },
    {
        type: 'text',
        model: 'first_name',
        placeholder: 'First Name',
        rules: 'required|max:100'
    },
    {
        type: 'email',
        model: 'email',
        placeholder: 'Email',
        rules: 'required|email'
    },
    {
        type: 'text',
        model: 'cell_phone',
        placeholder: 'Cell Phone',
        rules: 'required|digits:10'
    },
    {
        type: 'textarea',
        model: 'contact_us_msg',
        placeholder: 'Message',
        rules: 'required|max:1000'
    },
]
